module.exports = __webpack_public_path__ + "static/media/1016082.b7c080a3.png";